import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './styles.css';
import { handleKeySubmit } from '../../utilities/userUtil';

const NUMBER_OF_SLOTS_TO_DISPLAY = 5;

export default class DateAndTime extends Component {
  static propTypes = {
    appointments: PropTypes.arrayOf(PropTypes.shape({
      date: PropTypes.string,
      slots: PropTypes.arrayOf(PropTypes.string)
    })),
    location: PropTypes.string,
    selected: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
  }

  static defaultProps = {
    location: null,
    selected: null
  }

  constructor(props) {
    super(props);
    this.state = {
      week: 0,
      daysIndex: this.getDaysIndex(0)
    };
  }

  getDaysIndex = (index) => {
    const week = this.props.appointments[index];
    const daysIndex = week.days.reduce((accumulator, currentValue) => {
      accumulator[currentValue.date] = 0;
      return accumulator
    }, {});

    return daysIndex;
  }

  getWeekString = () => {
    const week = this.props.appointments[this.state.week];
    const weekStart = moment(week.days[0].date);
    const weekEnd = moment(week.days[week.days.length - 1].date);
    let start = '';
    let end = '';

    if (weekStart.isSame(weekEnd, 'month')) {
      start = weekStart.format('MMMM D');
      end = weekEnd.format('D');
    } else {
      start = weekStart.format('MMMM D');
      end = weekEnd.format('MMMM D');
    }

    return `Week of ${start} - ${end}`;
  }

  handleWeekChange = (diff) => {
    let week = this.state.week + diff;
    const maxWeek = this.props.appointments.length - 1;
    if (week < 0) {
      week = 0;
    } else if (week > maxWeek) {
      week = maxWeek;
    }
    this.setState({ week, daysIndex: this.getDaysIndex(week) });
  }

  handleDayChange = (day, diff) => {
    const date = day.date;
    const currentIndex = this.state.daysIndex[date];
    let newIndex = currentIndex + diff;
    const maxDay = day.slots.length - 1;

    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex > maxDay) {
      newIndex = maxDay;
    }

    if (newIndex > (day.slots.length - NUMBER_OF_SLOTS_TO_DISPLAY)) {
      newIndex = (day.slots.length - NUMBER_OF_SLOTS_TO_DISPLAY);
    }

    this.setState({
      daysIndex: {
        ...this.state.daysIndex,
        [date]: newIndex
      }
    });
  }

  renderDays = () => {
    const week = this.props.appointments[this.state.week];
    const days = week.days;

    return days.map((day) => {
      const startIndex = this.state.daysIndex[day.date];
      const endIndex = startIndex + NUMBER_OF_SLOTS_TO_DISPLAY;
      const slots = day.slots.slice(startIndex, endIndex);
      const isMinDay = startIndex === 0;
      const isMaxDay = endIndex === day.slots.length;

      // TODO: this is going to change once we know how the dates will be formatted
      let selectedSlot = null;
      let selectedDay = null;
      if (this.props.selected) {
        const selected = this.props.selected.split('--');
        selectedDay = selected[0];
        selectedSlot = selected[1];
      }

      return (
        <div key={day.date} className="date__time__day">
          <div className="date__time__date h3">{moment(day.date).format('dddd, MMMM Do')}</div>
          <div className="date__time__row">
            <img
              alt=""
              className={`date__time__arrow ${isMinDay ? 'date__time__arrow--disabled' : ''}`}
              src={require('assets/icons/left-arrow.svg')}
              onClick={() => this.handleDayChange(day, -1)}
              onKeyDown={(event) => handleKeySubmit(event.keyCode, () => this.handleDayChange(day, -1))}
              tabIndex="0"
            />
            <div className="date__time__options">
              {slots.map((slot) => {
                const isSelected = selectedDay === day.date && selectedSlot === slot;
                return (
                  <div
                    key={slot}
                    className={`date__time__option ${isSelected ? 'date__time__option--selected' : ''} type__body`}
                    onClick={() => this.props.onSelect(`${day.date}--${slot}`)}
                    onKeyDown={(event) => handleKeySubmit(event.keyCode, () => this.props.onSelect(`${day.date}--${slot}`))}
                    tabIndex="0">
                    {slot}
                  </div>
                )
              })}
            </div>
            <img
              alt=""
              className={`date__time__arrow ${isMaxDay ? 'date__time__arrow--disabled' : ''}`}
              src={require('assets/icons/right-arrow.svg')}
              onClick={ () => this.handleDayChange(day, 1)}
              onKeyDown={(event) => handleKeySubmit(event.keyCode, () => this.handleDayChange(day, 1))}
              tabIndex="0" />
          </div>
        </div>
      );
    });
  }

  render() {
    const { location, appointments } = this.props;
    const { week } = this.state;

    const isMinWeek = week === 0;
    const isMaxWeek = week === appointments.length - 1;

    return (
      <div className="date__time">
        {
          location && (
            <div className="date__time__location">
              <img
                alt=""
                className="date__time__marker"
                src={require('assets/icons/location-dark.svg')}
              />
              <span className="date__time__name h3">{location}</span>
            </div>
          )
        }
        <div className="date__time__controls">
          <img
            alt=""
            className={`date__time__arrow ${isMinWeek ? 'date__time__arrow--disabled' : ''}`}
            src={require('assets/icons/left-arrow.svg')}
            onKeyDown={(event) => handleKeySubmit(event.keyCode, () => this.handleWeekChange(-1))}
            tabIndex="0"
          />
          <div className="type__body">{this.getWeekString()}</div>
          <img
            alt=""
            className={`date__time__arrow ${isMaxWeek ? 'date__time__arrow--disabled' : ''}`}
            src={require('assets/icons/right-arrow.svg')}
            onKeyDown={(event) => handleKeySubmit(event.keyCode, () => this.handleWeekChange(1))}
            tabIndex="0"
          />
        </div>
        {this.renderDays()}
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/DateAndTime/DateAndTime.js